import script from "./MyButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MyButton.vue?vue&type=script&setup=true&lang=js"

import "./MyButton.vue?vue&type=style&index=0&id=2e5c8382&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5c8382"]])

export default __exports__